module.exports = __webpack_public_path__ + "fonts/Gilroy-300.d90fa98.otf";